(function ($) {
    function getInt($element, attribute, fallback) {
        var value = parseInt($element.attr(attribute), 10);

        return Number.isNaN(value) ? fallback : value;
    }

    function getBool($element, attribute) {
        return $element.attr(attribute) === '1';
    }

    function getSlideBy($element) {
        return $element.attr('data-slide-by') === 'page' ? 'page' : 1;
    }

    function getNavText() {
        return [
            "<span class='sr-only'>Previous slide</span><i class='icon-angle-left' aria-hidden='true'></i>",
            "<span class='sr-only'>Next slide</span><i class='icon-angle-right' aria-hidden='true'></i>",
        ];
    }

    function cleanDuplicateControls($carousel) {
        $carousel.children('.owl-nav').not(':first').remove();
        $carousel.children('.owl-dots').not(':first').remove();
    }

    function syncCarouselWidth($carousel) {
        var $parent = $carousel.parent();
        var parentWidth = Math.floor($parent.innerWidth());

        if (parentWidth > 0) {
            $carousel.css('width', parentWidth + 'px');
        }
    }

    function refreshCarousel($carousel) {
        syncCarouselWidth($carousel);
        $carousel.trigger('refresh.owl.carousel');
        cleanDuplicateControls($carousel);
    }

    function initCarousel(selector, defaults) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var desktopItems = getInt($carousel, 'data-items-desktop', defaults.desktopItems);
            var tabletItems = getInt($carousel, 'data-items-tablet', defaults.tabletItems);
            var mobileItems = getInt($carousel, 'data-items-mobile', defaults.mobileItems);
            var itemCount = getInt($carousel, defaults.countAttribute, 0);
            var hasMultiplePages = itemCount > desktopItems;
            var gap = getInt($carousel, 'data-gap', defaults.gap);
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultiplePages;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultiplePages;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                margin: gap,
                items: desktopItems,
                slideBy: getSlideBy($carousel),
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultiplePages,
                dots: dots && hasMultiplePages,
                navText: getNavText(),
                responsive: {
                    0: { items: mobileItems },
                    768: { items: tabletItems },
                    1200: { items: desktopItems },
                },
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initSingleSlideCarousel(selector) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var slideCount = getInt($carousel, 'data-slide-count', 0);
            var hasMultipleSlides = slideCount > 1;
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultipleSlides;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultipleSlides;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 1,
                margin: 0,
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultipleSlides,
                dots: dots && hasMultipleSlides,
                navText: getNavText(),
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function refreshCarousels() {
        $('.gallery-slider.owl-carousel, .block-cpt-slider.owl-carousel, .taxonomy-posts-slider.owl-carousel, .logos-slider.owl-carousel, .grid-card-slider.owl-carousel, .text-image-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                refreshCarousel($carousel);
            }
        });
    }

    function debounce(callback, delay) {
        var timer = null;

        return function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, delay);
        };
    }

    function asArray(selector, context) {
        return Array.prototype.slice.call((context || document).querySelectorAll(selector));
    }

    function initBlockAnimations() {
        var gsap = window.gsap;
        var ScrollTrigger = window.ScrollTrigger;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var root = document.documentElement;

        if (window.ddMotionFallback) {
            window.clearTimeout(window.ddMotionFallback);
            window.ddMotionFallback = null;
        }

        if (root.classList.contains('dd-motion-fallback')) {
            return;
        }

        if (!gsap || reduceMotion) {
            root.classList.add('dd-motion-ready');
            return;
        }

        if (ScrollTrigger) {
            gsap.registerPlugin(ScrollTrigger);
        }

        var animatedSections = [];

        function reveal(targets, vars) {
            targets = Array.isArray(targets) ? targets.filter(Boolean) : asArray(targets);

            if (!targets.length) {
                return;
            }

            var firstTarget = targets[0];
            var trigger = vars.trigger || firstTarget;
            var fromVars = vars.from || {};
            var toVars = vars.to || {};

            var setVars = $.extend({}, fromVars);
            var animationVars = $.extend({
                autoAlpha: 1,
                y: 0,
                x: 0,
                scale: 1,
                filter: 'none',
                duration: 1.22,
                ease: 'power3.out',
                stagger: 0.12,
            }, toVars);

            gsap.set(targets, setVars);

            if (!animationVars.clearProps) {
                animationVars.clearProps = 'opacity,visibility,transform,filter';
            }

            if (!ScrollTrigger) {
                gsap.to(targets, animationVars);
                return;
            }

            var playReveal = function () {
                gsap.killTweensOf(targets);
                gsap.set(targets, setVars);
                gsap.to(targets, animationVars);
            };
            var resetReveal = function () {
                gsap.killTweensOf(targets);
                gsap.set(targets, setVars);
            };

            ScrollTrigger.create({
                trigger: trigger,
                start: vars.start || 'top 70%',
                end: vars.end || 'bottom top',
                onEnter: playReveal,
                onEnterBack: playReveal,
                onLeave: resetReveal,
                onLeaveBack: resetReveal,
            });
        }

        function revealNow(targets, vars) {
            targets = Array.isArray(targets) ? targets.filter(Boolean) : asArray(targets);

            if (!targets.length) {
                return;
            }

            gsap.from(targets, $.extend({
                duration: 1.05,
                ease: 'power3.out',
                stagger: 0.1,
            }, vars || {}));
        }

        function createRevealTrigger(trigger, start, callback, resetCallback) {
            if (!ScrollTrigger) {
                callback();
                return;
            }

            ScrollTrigger.create({
                trigger: trigger,
                start: start || 'top 72%',
                end: 'bottom top',
                onEnter: callback,
                onEnterBack: callback,
                onLeave: resetCallback,
                onLeaveBack: resetCallback,
            });
        }

        function revealSectionHeader(section) {
            var headerItems = asArray('.section-header .main-subtitle, .section-header .main-title, .section-header-description', section);

            reveal(headerItems, {
                trigger: section,
                from: { autoAlpha: 0, y: 32 },
                to: { duration: 1.15, stagger: 0.12 },
            });
        }

        function revealTextStack(section, selector) {
            var items = asArray(selector, section);

            reveal(items, {
                trigger: section,
                from: { autoAlpha: 0, y: 30 },
                to: { duration: 1.18, stagger: 0.1 },
            });
        }

        function revealCards(section, selector) {
            reveal(asArray(selector, section), {
                trigger: section,
                start: 'top 74%',
                from: { autoAlpha: 0, y: 48, scale: 0.975 },
                to: { duration: 1.25, stagger: 0.12 },
            });
        }

        function revealFastCards(section, selector) {
            reveal(asArray(selector, section), {
                trigger: section,
                start: 'top 78%',
                from: { autoAlpha: 0, y: 24, scale: 0.99 },
                to: { duration: 0.68, stagger: 0.11, ease: 'power2.out' },
            });
        }

        function revealCptCards(section) {
            var cardItems = asArray('.block-cpt-item, .taxonomy-posts-card, .taxonomy-posts-slide, .block-cpt-taxonomy-term', section);

            reveal(cardItems, {
                trigger: section,
                start: 'top 78%',
                from: { autoAlpha: 0, y: 34, scale: 0.985 },
                to: { duration: 0.78, stagger: 0.065, ease: 'power2.out' },
            });
        }

        function revealMedia(section, selector) {
            asArray(selector, section).forEach(function (media) {
                var image = media.querySelector('img');

                var resetMedia = function () {
                    gsap.killTweensOf(media);

                    if (image) {
                        gsap.killTweensOf(image);
                    }

                    gsap.set(media, {
                        autoAlpha: 0,
                        clipPath: 'inset(10% 10% 10% 10%)',
                        y: 28,
                    });

                    if (image) {
                        gsap.set(image, { scale: 1.1 });
                    }
                };

                resetMedia();

                createRevealTrigger(media, 'top 74%', function () {
                    gsap.to(media, {
                        autoAlpha: 1,
                        clipPath: 'inset(0% 0% 0% 0%)',
                        y: 0,
                        duration: 1.35,
                        ease: 'power3.out',
                        clearProps: 'opacity,visibility,transform,clipPath',
                    });

                    if (image) {
                        gsap.to(image, {
                            scale: 1,
                            duration: 1.55,
                            ease: 'power3.out',
                            clearProps: 'transform',
                        });
                    }
                }, resetMedia);
            });
        }

        function addSoftParallax(section, selector) {
            if (!ScrollTrigger || window.innerWidth < 992) {
                return;
            }

            asArray(selector, section).forEach(function (image) {
                if (image.closest('.bg-with-text-fit-contain')) {
                    return;
                }

                image.classList.add('has-soft-parallax');

                gsap.to(image, {
                    yPercent: -7,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: image.closest('section') || image,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 0.7,
                    },
                });
            });
        }

        function revealStandalone() {
            asArray('#header-image.page-hero').forEach(function (hero) {
                var activeSlide = hero.querySelector('.carousel-item.active');
                var contentScope = activeSlide || hero;

                reveal(asArray('.page-hero-subtitle, .page-hero-title, .page-hero-description, .page-hero-buttons', contentScope), {
                    trigger: hero,
                    start: 'top 90%',
                    from: { autoAlpha: 0, y: 36 },
                    to: { duration: 1.25, stagger: 0.14 },
                });

                if (hero.classList.contains('page-hero-image')) {
                    reveal([hero], {
                        trigger: hero,
                        start: 'top 96%',
                        from: { filter: 'brightness(0.82)', scale: 1.015 },
                        to: { duration: 1.45, ease: 'power3.out' },
                    });
                }

                $(hero).find('.carousel').on('slide.bs.carousel', function (event) {
                    var nextSlide = event.relatedTarget;

                    if (!nextSlide) {
                        return;
                    }

                    revealNow(asArray('.page-hero-subtitle, .page-hero-title, .page-hero-description, .page-hero-buttons', nextSlide), {
                        autoAlpha: 0,
                        y: 28,
                        duration: 0.95,
                        stagger: 0.1,
                    });
                });
            });

            asArray('.single-post-hero, .single-apartment-hero').forEach(function (hero) {
                reveal(asArray('.single-post-hero-category, .single-post-hero-title, .single-post-hero-meta, .single-apartment-hero-subtitle, .single-apartment-hero-title, .single-apartment-hero-meta', hero), {
                    trigger: hero,
                    start: 'top 88%',
                    from: { autoAlpha: 0, y: 34 },
                    to: { duration: 1.2, stagger: 0.13 },
                });

                addSoftParallax(hero, '.single-apartment-hero-image');
            });

            asArray('.apartment-intro').forEach(function (section) {
                revealTextStack(section, '.apartment-copy > *, .apartment-actions');
                revealMedia(section, '.apartment-intro-image');
            });

            asArray('.apartment-features').forEach(function (section) {
                revealTextStack(section, '.apartment-section-heading > *');
                revealCards(section, '.apartment-feature, .apartment-feature-action');
            });

            asArray('.apartment-amenities').forEach(function (section) {
                revealMedia(section, '.apartment-amenities-image');
                revealTextStack(section, '.apartment-amenities-content > *, .apartment-amenities-text > *');
            });

//             asArray('.apartment-booking-cta, .site-footer-cta').forEach(function (section) {
//                 revealTextStack(section, '.apartment-booking-inner > *, .site-footer-cta-inner > *');
//             });

            asArray('.apartment-gallery').forEach(function (section) {
                revealCards(section, '.apartment-gallery-item');
            });

            asArray('.single-post-related').forEach(function (section) {
                revealTextStack(section, '.single-post-related-title');
                revealCards(section, '.single-post-related-column');
            });

            asArray('.contact-intro-section').forEach(function (section) {
                revealTextStack(section, '.contact-kicker, .contact-intro-content h1, .contact-intro-text > *, .contact-info-item');
                revealMedia(section, '.contact-map');
            });

            asArray('.contact-arrival-section').forEach(function (section) {
                revealTextStack(section, '.contact-section-heading > *');
                revealFastCards(section, '.arrival-card, .arrival-distance-item');
                revealTextStack(section, '.arrival-distances > h3');
            });

            asArray('#index-page').forEach(function (section) {
                revealFastCards(section, '.blog-post-column');
                revealTextStack(section, '.wp-pagenavi');
            });

            asArray('.apartment-card').forEach(function (card) {
                if (card.closest('section[class*="block_"]')) {
                    return;
                }

                reveal([card], {
                    trigger: card,
                    start: 'top 74%',
                    from: { autoAlpha: 0, y: 42, scale: 0.98 },
                    to: { duration: 1.2 },
                });
            });
        }

        asArray('section[class*="block_"]').forEach(function (section) {
            if (section.dataset.ddAnimated) {
                return;
            }

            section.dataset.ddAnimated = 'true';
            animatedSections.push(section);
            revealSectionHeader(section);

            if (section.classList.contains('block_text_image')) {
                revealTextStack(section, '.text-image-subtitle, .text-image-title, .text-image-content > p, .text-image-content > ul, .text-image-content > ol, .text-image-signature, .text-image-info-item, .dd-buttons, .text-image-info-grid');
                revealMedia(section, '.text-image-media');
                reveal(asArray('.text-image-secondary-image, .text-image-media-button', section), {
                    trigger: section,
                    start: 'top 70%',
                    from: { autoAlpha: 0, y: 28, scale: 0.94 },
                    to: { duration: 1.05, stagger: 0.1, delay: 0.22 },
                });
                addSoftParallax(section, '.text-image-media img');
                return;
            }

            if (section.classList.contains('block_master_text')) {
                revealTextStack(section, '.master-text-subtitle, .master-text-title, .master-text-content > p, .master-text-content > ul, .master-text-content > ol, .dd-buttons');
                return;
            }

            if (section.classList.contains('block_cpt') || section.classList.contains('block_taxonomy_posts')) {
                revealCptCards(section);
                return;
            }

            if (section.classList.contains('block_images')) {
                revealCards(section, '.gallery-item, .gallery-card, .gallery-lightbox-item, .gallery-slide, .owl-item:not(.cloned)');
                revealMedia(section, '.gallery-card, .gallery-image-wrap');
                return;
            }

            if (section.classList.contains('block_columns')) {
                revealCards(section, '.block-column, .column-content');
                return;
            }

            if (section.classList.contains('block_buttons')) {
                revealTextStack(section, '.dd-buttons, .dd-button-item, .btn');
                return;
            }

            if (section.classList.contains('block_logos')) {
                revealCards(section, '.logos-item, .logos-card, .logos-image, .owl-item:not(.cloned)');
                return;
            }

            if (section.classList.contains('block_grid_repeater_with_image')) {
                revealFastCards(section, '.grid-card-item');
                return;
            }

            if (section.classList.contains('block_accordion_or_tabs') || section.classList.contains('block_text_accordion')) {
                revealTextStack(section, '.text-accordion-content > *, .text-accordion-item, .accordion-tabs-item, .accordion-tabs-nav-item, .accordion-tabs-pane, .accordion-item, .nav-item');
                return;
            }

            if (section.classList.contains('block_timeline')) {
                revealCards(section, '.timeline-item, .timeline-dot, .timeline-content');
                return;
            }

            if (section.classList.contains('block_tables')) {
                revealTextStack(section, '.tables-title, .tables-description');
                revealCards(section, '.tables-group, .table-block, .tables-table tr');
                return;
            }

            if (section.classList.contains('block_bg_with_text')) {
                revealMedia(section, '.bg-with-text-wrapper');
                revealTextStack(section, '.bg-with-text-copy > *, .bg-with-text-content > *, .dd-buttons, .btn');
                addSoftParallax(section, '.bg-with-text-image');
                return;
            }

            revealTextStack(section, '.main-subtitle, .main-title, p, li, .btn, img');
        });

        revealStandalone();

        window.addEventListener('load', function () {
            if (ScrollTrigger && animatedSections.length) {
                ScrollTrigger.refresh();
            }
        });

        root.classList.add('dd-motion-ready');
    }

    function initLightboxes() {
        if (!$.fn.lightGallery) {
            return;
        }

        $('.gallery-lightbox').each(function () {
            var $gallery = $(this);

            if ($gallery.data('ddLightGallery')) {
                return;
            }

            $gallery.lightGallery({
                selector: '.gallery-lightbox-item',
                share: true,
                download: true,
                rotate: false,
                showThumbByDefault: true,
                loop: false,
                thumbnail: true,
                exThumbImage: 'data-thumb',
                enableThumbDrag: true,
                enableThumbSwipe: true,
                allowMediaOverlap: true,
                toogleThumb: true,
            });

            $gallery.data('ddLightGallery', true);
        });
    }

    $(function () {
        initLightboxes();

        initCarousel('.gallery-slider.owl-carousel', {
            countAttribute: 'data-image-count',
            desktopItems: 1,
            tabletItems: 1,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.block-cpt-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.taxonomy-posts-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.logos-slider.owl-carousel', {
            countAttribute: 'data-logo-count',
            desktopItems: 4,
            tabletItems: 3,
            mobileItems: 2,
            gap: 24,
        });

        initCarousel('.grid-card-slider.owl-carousel', {
            countAttribute: 'data-card-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initSingleSlideCarousel('.text-image-slider.owl-carousel');

        initBlockAnimations();

        $(window).on('load', refreshCarousels);
        $(window).on('resize orientationchange', debounce(refreshCarousels, 150));
    });
})(jQuery);
